import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import styles from "./Drawer.module.css";
/** Seletores de elementos focáveis (ordem padrão de tabulação) */
const FOCUSABLE_SELECTORS = [
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "[tabindex]:not([tabindex='-1'])",
    "details > summary",
].join(", ");
function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(FOCUSABLE_SELECTORS));
}
/**
 * Drawer lateral direito do Azim CRM.
 * Fecha com Esc ou clique no overlay.
 * Gerencia foco ao abrir/fechar.
 * Implementa focus trap: Tab/Shift+Tab cicla dentro do painel.
 */
export function Drawer({ open, onClose, children, width = 440, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, }) {
    const panelRef = useRef(null);
    useEffect(() => {
        if (!open)
            return;
        const previousFocus = document.activeElement;
        panelRef.current?.focus();
        const handleKey = (e) => {
            if (e.key === "Escape")
                onClose();
        };
        window.addEventListener("keydown", handleKey);
        return () => {
            window.removeEventListener("keydown", handleKey);
            previousFocus?.focus();
        };
    }, [open, onClose]);
    if (!open)
        return null;
    const handlePanelKeyDown = (e) => {
        if (e.key !== "Tab")
            return;
        const panel = panelRef.current;
        if (!panel)
            return;
        const focusable = getFocusableElements(panel);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!first || !last) {
            e.preventDefault();
            return;
        }
        if (e.shiftKey) {
            if (document.activeElement === first || document.activeElement === panel) {
                e.preventDefault();
                last.focus();
            }
        }
        else {
            if (document.activeElement === last || document.activeElement === panel) {
                e.preventDefault();
                first.focus();
            }
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.overlay, onMouseDown: onClose, role: "none" }), _jsx("div", { ref: panelRef, className: styles.panel, style: { width: "100%", maxWidth: width }, role: "dialog", "aria-modal": "true", "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, tabIndex: -1, onKeyDown: handlePanelKeyDown, children: children })] }));
}
//# sourceMappingURL=Drawer.js.map